import React from 'react';

const FlowNodeStatus = React.memo(({ text }) => {
  return (
    <div className="bg-primary h-[14px] text-ten px-[4px] rounded-[1px] leading-[14px] absolute -right-[1px] -top-[6px] text-white">
      {text}
    </div>
  );
});

export default FlowNodeStatus;
